"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function EnablesyncMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M2.97 10.854a.4.4 0 01-.36-.229A6.01 6.01 0 012 7.957a6.142 6.142 0 016.166-6.11c.345 0 .69.028 1.03.084a.406.406 0 11-.132.801 5.152 5.152 0 00-.898-.076 5.34 5.34 0 00-5.365 5.301 5.208 5.208 0 00.521 2.304.401.401 0 01-.184.537.453.453 0 01-.168.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M9.865 4.816l2.031-2.003a.457.457 0 000-.653L9.865.156a.46.46 0 00-.781.329v4.003a.46.46 0 00.781.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M9.885 1.282l1.202 1.202-1.202 1.202V1.282zM9.545 0a.457.457 0 00-.461.46v4.027a.46.46 0 00.781.329l2.031-2.003a.457.457 0 000-.653L9.865.156a.457.457 0 00-.32-.132V0zM8.094 14.18c-.345 0-.69-.028-1.03-.085a.406.406 0 01.133-.801c.296.051.596.077.897.076a5.34 5.34 0 005.365-5.3 5.244 5.244 0 00-.52-2.312.4.4 0 01.72-.349 6.04 6.04 0 01.133 5.01 6.14 6.14 0 01-5.698 3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M6.395 11.21l-2.03 2.004a.456.456 0 000 .653l2.03 2.003a.461.461 0 00.782-.329v-4.006a.46.46 0 00-.782-.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M6.375 12.36v2.404l-1.202-1.202 1.202-1.202zm.341-1.282a.457.457 0 00-.32.133l-2.032 2.003a.456.456 0 000 .653l2.031 2.003a.46.46 0 00.782-.328v-4.007a.457.457 0 00-.461-.46v.003zM7.553 10.085L5.442 7.96a.4.4 0 11.569-.565l1.546 1.559 2.697-2.66a.401.401 0 11.56.552l-3.26 3.238z"
  }));
}

EnablesyncMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
EnablesyncMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = EnablesyncMultitoneFilled;
exports["default"] = _default;